var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShapeDiverCommonsTicketType = void 0;
var ShapeDiverCommonsTicketType;
(function (ShapeDiverCommonsTicketType) {
  ShapeDiverCommonsTicketType["BACKEND"] = "backend";
  ShapeDiverCommonsTicketType["NONE"] = "";
})(ShapeDiverCommonsTicketType || (exports.ShapeDiverCommonsTicketType = ShapeDiverCommonsTicketType = {}));
//# sourceMappingURL=SdCommonsTicket.js.map
export default exports;